export default __webpack_public_path__ + "static/media/off-7.1b0e6723.png";